import React, { Component } from 'react';
import moment from 'moment';
import CONSTANTS from "../../../constants";

export default class Confirm extends Component {

    confirmSignUp() {
        this.props.callbackToUpdateComponent({confirm: true});
    }

    render () {
        const klass = this.props.class;
        return (
            <div>
                <div className='col-xs-12 col-md-6 col-lg-6'>
                    <div className='info-box'>
                        <h3>When</h3>
                        <div>{moment(klass.start_date, CONSTANTS.DATE.FORMAT.DEFAULT).format('dddd, MMMM D, YYYY')}</div>
                    </div>
                </div>
                <div className='col-xs-6 col-md-6 col-lg-6'>
                    <div className='info-box'>
                        <h3>What</h3>
                        <div>{klass.activity_name}</div>
                    </div>
                </div>
                <div className='col-xs-6 col-md-12 col-lg-12'>
                    <div className='info-box'>
                        <h3>With</h3>
                        <div>{klass.trainer_name}</div>
                    </div>
                </div>
                <div className='col-xs-12 col-md-12 col-lg-12'>
                    <button className='btn btn-primary' onClick={this.confirmSignUp.bind(this)} >Confirm</button>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/appointments/signup/confirm.js